import React, { useRef, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
type CinematicButtonProps = {
  children: React.ReactNode;
  href: string;
  variant?: "primary" | "secondary";
  external?: boolean;
  icon?: React.ReactNode;
  cursor?: string;
  className?: string;
};
export function CinematicButton({
  children,
  href,
  variant = "primary",
  external = false,
  icon,
  cursor = "Open",
  className = ""
}: CinematicButtonProps) {
  const ref = useRef<HTMLAnchorElement>(null);
  const reduceMotion = useReducedMotion();
  const [offset, setOffset] = useState({
    x: 0,
    y: 0
  });
  const onMove = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (reduceMotion || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setOffset({
      x: (event.clientX - rect.left - rect.width / 2) * 0.12,
      y: (event.clientY - rect.top - rect.height / 2) * 0.18
    });
  };
  const base = "group relative inline-flex min-h-[54px] items-center justify-between gap-8 overflow-hidden rounded-xl px-6 text-sm font-semibold uppercase tracking-[0.08em] transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[#050808]";
  const skin = variant === "primary" ? "bg-[#54f6c6] text-[#05100d] focus-visible:ring-white" : "border border-white/20 text-white hover:border-white/60 focus-visible:ring-[#54f6c6]";
  return <motion.a ref={ref} href={href} data-cursor={cursor} target={external ? "_blank" : undefined} rel={external ? "noreferrer" : undefined} className={`${base} ${skin} ${className}`} onMouseMove={onMove} onMouseLeave={() => setOffset({
    x: 0,
    y: 0
  })} animate={offset} transition={{
    type: "spring",
    stiffness: 220,
    damping: 20
  }} data-id="element-34" data-mp="18arkffksetmu">
      {variant === "primary" && <span className="absolute inset-0 -translate-x-full bg-white/70 transition-transform duration-500 group-hover:translate-x-0" data-id="element-35" data-mp="kjci3mt0gcbl" />}
      <span className="relative" data-id="element-36" data-mp="9wxmms2zqfhf">{children}</span>
      <span className="relative transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-37" data-mp="a0bp00bnmoov">{icon ?? <ArrowUpRight className="h-4 w-4" data-id="element-38" data-mp="xu53sjh2851" />}</span>
    </motion.a>;
}